var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransportation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 115,
    height: 115,
    rx: 25,
    fill: "#3CBD96"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_150_66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.5532 36.2766H83.6383V52.0745L94.3617 57.3404V73.1383H84.867",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0691 80.9574C34.4423 80.9574 30.6915 77.4566 30.6915 73.1382C30.6915 68.8198 34.4423 65.3191 39.0691 65.3191C43.696 65.3191 47.4468 68.8198 47.4468 73.1382C47.4468 77.4566 43.696 80.9574 39.0691 80.9574Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9309 80.9574C71.304 80.9574 67.5532 77.4566 67.5532 73.1382C67.5532 68.8198 71.304 65.3191 75.9309 65.3191C80.5577 65.3191 84.3085 68.8198 84.3085 73.1382C84.3085 77.4566 80.5577 80.9574 75.9309 80.9574Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4468 73.1383H67.5532V31.8085H20.6383V73.1383H30.133",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0319 41.8617L58.617 46.8883L53.0319 51.9149",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5 47.4468H38.734C36.601 47.4468 34.5554 48.2706 33.0471 49.737C31.5388 51.2033 30.6915 53.1922 30.6915 55.2659",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_150_66"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105,
    height: 105,
    fill: "white",
    transform: "matrix(-1 0 0 1 110 5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportation);
export default __webpack_public_path__ + "static/media/transportation.41c5db2f52303d7ace6f72eae78f1be5.svg";
export { ForwardRef as ReactComponent };